  <div class="my-1" fxLayout="row" fxLayoutAlign="center center" style="overflow: hidden;">
    <form [formGroup]="form">
      <re-captcha formControlName="resolved"></re-captcha>
    </form>
  </div>
